import React from 'react';
import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

interface BadgeItemProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  image: React.ReactNode;
}

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutrals.grey1};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    flex-direction: row;
    gap: ${theme.spacing(3)};
  `}
`;

const ItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  text-align: center;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    max-width: 252px;
    text-align: initial;
  `}
`;

const ItemRight = styled.div`
  width: 200px;
  height: 200px;
`;

const TitleText = styled(H3)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-size: ${typographyFontSizeCfg.h1.mobile}px;
  line-height: ${typographyLineHeightCfg.h1.mobile}px;
`;

const DescriptionText = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;

export const BadgeItem: React.FC<BadgeItemProps> = ({ title, subtitle, image }) => {
  return (
    <Item>
      <ItemRight>
        {image}
      </ItemRight>
      <ItemLeft>
        <TitleText weight="bold">
          {title}
        </TitleText>
        <DescriptionText>
          {subtitle}
        </DescriptionText>
      </ItemLeft>
    </Item>
  );
};
